<template>
	<div class="container-fluid d-flex h-100 w-100" :style="background">
		<div v-if="te('start_buttons')" class="row my-auto w-100 justify-content-center start-button-container-offset" >
			<StartScreenButton v-for="(button, index) in tm('start_buttons')" :totalButtons="tm('start_buttons').length" :title="button.title" :text="button.text" :link="button.page" :article="button.article" :categories="button.categories" :index="index" :key="button"></StartScreenButton>
		</div>
	</div>
</template>

<script>
import StartScreenButton from "@/components/startscreen/Button.vue";
import { useI18n } from 'vue-i18n';
import store from "../store";

export default {
	name: "Home",
	computed: {
		background() {
			if(store.state.settings.colors.start_screen.use_image)
			{
				return `background-image: url('${store.state.settings.colors.start_screen.background_image}');`;
				// return `background-image: url(../img/background-home.png)`;
			} else {
				return `background-color: ${store.state.settings.colors.start_screen.background_color};`;
			}
			
		},
		marginTop()
		{
			if(this.TotalButtons > 6)
			{
				return '160px';
			}
			
			return 'auto';
		}
	},
	components: {
		StartScreenButton,
	},
	data() {
		return {
			TotalButtons: 6,
		};
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	mounted() {
		const { tm } = useI18n();

		this.TotalButtons = tm('start_buttons').length;

	},
};
</script>
<style scoped>
.museum-home-background {
	background-image: url("~@/assets/img/background-home.png");
}

.start-button-container-offset {
	margin-top: v-bind(marginTop) !important;
}

.grid-container {
	display: grid;
	row-gap: 32px;
	column-gap: 70px;
	grid-template-columns: 500px 500px 500px;
	grid-template-rows: repeat(auto-fill, 274px);
	align-items: center;
	justify-items: center;
}

.museum-start-screen-gutter {
    --bs-gutter-x: 70px;
}
</style>